// client/src/api/core/errors.ts

export class SessionExpiredError extends Error {
  readonly name = 'SessionExpiredError' as const;

  constructor(message = 'Session expired') {
    super(message);
    // Necessario in TS quando si estende Error con target < ES2022
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class PaywallError extends Error {
  readonly name = 'PaywallError' as const;
  readonly feature?: string;
  /**
   * Status HTTP che ha originato il paywall.
   * 403 → paywall rider (requirePlusTier, checkRouteLimit, cerchia);
   * 402 → paywall dealer (checkDealerFeature / checkDealerLimits).
   * Esposto perché diversi componenti (DealerFollowups, GeoPromoCard,
   * DealerShowcase) discriminano ancora sul vecchio `e.status === 402`:
   * senza questo campo la conversione a PaywallError li romperebbe.
   */
  readonly status: number;

  constructor(
    message = 'Questa funzionalità richiede Rider Plus.',
    feature?: string,
    status = 403,
  ) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.feature = feature;
    this.status = status;
  }
}

/**
 * Lanciato quando il server richiede MFA per accedere al pannello admin.
 * Il client deve intercettarlo e mostrare la schermata di setup MFA.
 */
export class AdminMfaRequiredError extends Error {
  readonly name = 'AdminMfaRequiredError' as const;
  readonly setupUrl: string;

  constructor(message = 'MFA richiesto per accedere al pannello admin.', setupUrl = '/admin/security') {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.setupUrl = setupUrl;
  }
}

export class NetworkError extends Error {
  readonly name = 'NetworkError' as const;
  readonly status: number;

  constructor(message: string, status = 0) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.status = status;
  }
}

// Type guard — usato in apiFetch e tokenRefresh
export function isNetworkError(e: unknown): e is TypeError {
  if (!(e instanceof TypeError)) return false;
  const msg = String(e.message).toLowerCase();
  return (
    msg.includes('failed to fetch') ||
    msg.includes('network') ||
    msg.includes('connection')
  );
}
